import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as baseState from '../../../core/models/base-state/base-state';
import { PatientProvider } from '../../models/patient-provider';
import { getPatientCareTeam, getPatientCareTeamFailure, getPatientCareTeamSuccess } from '../actions/care-team.actions';

export const careTeamFeatureKey = 'care-team';

export interface CareTeamState extends EntityState<PatientProvider> {
  baseState: baseState.BaseState;
}

export const careTeamAdapter = createEntityAdapter<PatientProvider>({
  selectId: careTeam => careTeam.providerUserId,
});

export const initialState: CareTeamState = careTeamAdapter.getInitialState({
  baseState: baseState.createBaseState(undefined),
});

export const careTeamReducer = createReducer<CareTeamState>(
  initialState,

  on(getPatientCareTeam, (state): CareTeamState => {
    return {
      ...careTeamAdapter.removeAll(state),
      baseState: {
        ...state.baseState,
        error: null,
        isLoading: true,
      },
    };
  }),

  on(getPatientCareTeamSuccess, (state, { careTeam }): CareTeamState => {
    if (careTeam !== null) return careTeamAdapter.addMany(careTeam, state);
    return state;
  }),

  on(getPatientCareTeamSuccess, (state): CareTeamState => {
    return {
      ...state,
      baseState: {
        ...state.baseState,
        error: null,
        isLoading: false,
      },
    };
  }),

  on(getPatientCareTeamFailure, (state, { error }): CareTeamState => {
    return {
      ...state,
      baseState: {
        ...state.baseState,
        error,
        isLoading: false,
      },
    };
  })
);
